import { IonBadge, IonCol, IonImg, IonRow } from "@ionic/react";
import { User } from "../../types/user";

import { useHistory } from "react-router";
import "./Me.css";
interface Props {
  user: User;
}

const AccountImg: React.FC<Props> = ({ user }) => {
  const history = useHistory();
  return (
    <IonRow class="ion-align-items-center">
      <IonCol
        style={{ maxHeigh: "100px" }}
        size="12"
        sizeSm="12"
        sizeLg="12"
        class="flex ion-justify-content-center ion-align-items-center"
      >
        <div className="relative">
          <IonBadge className="badge" id="badgeXP">
            niveau : {user.level}
          </IonBadge>

          <IonImg
            onClick={() => history.push("/account")}
            // onClick={() => (window.location.href = "/account")}
            className="app-logo round-avatar"
            src={user.picture_url}
            alt="Image de profil"
          />
        </div>
      </IonCol>
    </IonRow>
  );
};

export default AccountImg;
